@if (showBanner()) {
  <section
    class="cookie-banner"
    role="dialog"
    aria-live="polite"
    [attr.aria-label]="'cookie.banner.title' | translate"
  >
    <div class="cookie-banner__content">
      <p class="cookie-banner__text">
        {{ 'cookie.banner.message' | translate }}
        <a class="cookie-banner__privacy-link" href="/privacy">
          {{ 'cookie.banner.privacyLink' | translate }}
        </a>
      </p>

      <div class="cookie-banner__actions">
        <button type="button" class="btn-primary" (click)="acceptAll()">
          {{ 'cookie.banner.accept' | translate }}
        </button>
        <button
          type="button"
          class="btn-secondary"
          (click)="acceptOnlyNecessary()"
        >
          {{ 'cookie.banner.acceptNecessary' | translate }}
        </button>
      </div>
    </div>
  </section>
}
